import {
  AuthClient,
  AuthIdTokenParsed,
  AuthOptions,
  createAuthClient,
} from '@storebrand-digital/auth';
import { isOfflineMode } from 'Utils/isOfflineMode.utils';
import { allowedACRs } from './keycloakWrapper.helpers';

const options: AuthOptions = {
  config: {
    url: window.env.KEYCLOAK_URL,
    clientId: window.env.KEYCLOAK_CLIENT,
    realm: window.env.KEYCLOAK_REALM,
  },
  init: {
    scope: window.env.KEYCLOAK_SCOPES,
  },
  login: {
    scope: window.env.KEYCLOAK_SCOPES,
    allowedACR: [allowedACRs.al3, allowedACRs.al4],
  },
  logout: {
    redirectUri: window.env.KEYCLOAK_LOGOUT_URL,
  },
  autoRefresh: true,
};

const auth = createAuthClient(options);

export const authenticate = async (): Promise<void> => {
  if (isOfflineMode()) {
    return;
  }

  await auth.init();
  await auth.login();
};

export function getNin(): string {
  if (isOfflineMode()) {
    return '12345612345';
  }
  return auth.nin;
}

export function login(): Promise<unknown> {
  if (isOfflineMode()) {
    return Promise.resolve(undefined);
  }
  return auth.login();
}

export function logout(): Promise<unknown> {
  if (isOfflineMode()) {
    return Promise.resolve();
  }
  return auth.logout();
}

export function isAuthenticated(): boolean {
  if (isOfflineMode()) {
    return true;
  }
  return auth.authenticated ?? false;
}

export function getAccessToken(): Promise<string> {
  if (isOfflineMode()) {
    return Promise.resolve('');
  }
  return auth.getToken();
}

export function getInstance(): AuthClient['instance'] | undefined {
  if (isOfflineMode()) {
    return undefined;
  }
  return auth.instance;
}

export function refreshTokenParsed():
  | AuthClient['instance']['refreshTokenParsed']
  | undefined {
  if (isOfflineMode()) {
    return undefined;
  }
  return auth.instance.refreshTokenParsed;
}

export function getIdTokenParsed(): AuthIdTokenParsed | undefined {
  if (isOfflineMode()) {
    return {
      no_nin: '12345612345',
      given_name: '',
      family_name: '',
    } as unknown as AuthIdTokenParsed;
  }
  return isAuthenticated() ? auth.idTokenParsed : undefined;
}
